export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '付款通知单列表',
} as TCommon.RouteConfig
